// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"R3-z","dimensionLabel":"S3-z","styleChooserControlWrapper":"T3-z","styleChooserControl":"U3-z","disabled":"V3-z","giftCard":"W3-z","styleChooserText":"X3-z"};